// Типизированные API функции для работы со справочниками

import { clientCC } from '../services/HttpService';
import { baseURL } from './Environment';
import type {
  ApiResponse,
  Region,
  Country,
  Sex,
  MaritalStatus,
  RejectionReason,
  TerritorialDirection,
  PointOfSale,
} from '../types';

/**
 * Получение списка регионов
 */
export const fetchRegions = async (): Promise<Region[]> => {
  const response = await clientCC.get<ApiResponse<Region[]>>(`${baseURL}/references/regions`);
  return response.data.content;
};

/**
 * Получение списка стран
 */
export const fetchCountries = async (): Promise<Country[]> => {
  const response = await clientCC.get<ApiResponse<Country[]>>(`${baseURL}/references/countries`);
  return response.data.content;
};

/**
 * Получение справочника пола
 */
export const fetchSex = async (): Promise<Sex[]> => {
  const response = await clientCC.get<ApiResponse<Sex[]>>(`${baseURL}/references/sex`);
  return response.data.content;
};

/**
 * Получение справочника семейного положения
 */
export const fetchMaritalStatuses = async (): Promise<MaritalStatus[]> => {
  const response = await clientCC.get<ApiResponse<MaritalStatus[]>>(
    `${baseURL}/references/marital-statuses`
  );
  return response.data.content;
};

/**
 * Получение причин отказа
 * @param rejectedByClient - Отказ по инициативе клиента
 */
export const fetchRejectionReasons = async (
  rejectedByClient: boolean
): Promise<RejectionReason[]> => {
  const response = await clientCC.get<ApiResponse<RejectionReason[]>>(
    `${baseURL}/references/rejection-reasons/${rejectedByClient}`
  );
  return response.data.content;
};

/**
 * Получение списка территориальных дирекций
 */
export const fetchTerritorialDirections = async (): Promise<TerritorialDirection[]> => {
  const response = await clientCC.get<ApiResponse<TerritorialDirection[]>>(
    `${baseURL}/references/territorial-directions`
  );
  return response.data.content;
};

/**
 * Получение списка точек продаж по территориальной дирекции
 * @param tdId - ID территориальной дирекции
 */
export const fetchPointsOfSale = async (tdId: number): Promise<PointOfSale[]> => {
  const response = await clientCC.get<ApiResponse<PointOfSale[]>>(
    `${baseURL}/references/points-of-sale`,
    { params: { territorialDirectionId: tdId } }
  );
  return response.data.content;
};

/**
 * Получение цены страхового продукта
 * @param amount - Сумма займа
 */
export const fetchInsuranceProductPrice = async (
  amount: number
): Promise<{ price: number } | false> => {
  try {
    const response = await clientCC.get<{ price: number }>(
      `${baseURL}/references/insurance-product`,
      { params: { amount } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching insurance product price:', error);
    return false;
  }
};
